export default __webpack_public_path__ + "static/media/treble.06a94312.svg";